import {
  Button,
  CircularProgress,
  Grid,
  Typography,
  WithStyles
} from '@material-ui/core'
import DateRangeIcon from '@material-ui/icons/DateRange'
import TimeRangeIcon from '@material-ui/icons/WatchLaterOutlined'
import { TFunction } from 'i18next'
import moment from 'moment'
import { FC, Fragment, useState } from 'react'
import { OpenDialog, ReserveShowingAction } from '../../../../actions/types'
import customCloseIcon from '../../../../images/customCloseIcon.svg'
import { ReservableShowing, ReserveData } from '../../../../types/showings'
import Suggest from '../../../Apartment/Stepper/Steps/Suggest'
import Dialog from '../../../Dialog'
import ReservableCard from './ReservableCard'

interface SuggestReservableCardProps extends WithStyles {
  invitedShowings: any
  reserveShowing: ReserveShowingAction
  t: TFunction
  openDialog: OpenDialog
  reserveData: ReserveData
}

const SuggestReservableCard: FC<SuggestReservableCardProps> = ({
  invitedShowings,
  classes,
  t,
  reserveShowing,
  openDialog,
  reserveData
}: SuggestReservableCardProps) => {
  const bestReservable = reserveData?.reservableShowings?.bestReservables.map(
    ({ showingId }) => showingId
  )
  const [isLoading, setIsLoaing] = useState<boolean>(false)
  const reservableCardProps = {
    classes,
    t,
    openDialog,
    bestReservable,
    reserveData
  }

  const showingsWithoutBestReservable = invitedShowings
    .filter(({ showingId }: any) => !bestReservable.includes(showingId))
    .sort(
      (dateFirst: any, dateSecond: any) =>
        Date.parse(dateFirst.startDate) - Date.parse(dateSecond.startDate)
    )

  const showingsWithBestReservable = invitedShowings
    .filter(({ showingId }: any) => bestReservable.includes(showingId))
    .sort(
      (dateFirst: any, dateSecond: any) =>
        Date.parse(dateFirst.startDate) - Date.parse(dateSecond.startDate)
    )
  const showingsToMap = [
    ...showingsWithBestReservable,
    ...showingsWithoutBestReservable
  ]

  return (
    <Grid container justify='center' className={classes.cardWapper}>
      {showingsToMap.map((showing: ReservableShowing) => {
        const date = moment(showing.startDate)
        return (
          <Fragment key={showing.showingId}>
            <Grid item xs={12} className={classes.cardContainer}>
              <ReservableCard {...reservableCardProps} showing={showing} />
            </Grid>
            <Dialog
              dialogId={`ReserveConfirmationDialog${showing.showingId}`}
              confirmLabel={t('general.reserve')}
              noOpenDialogButton
              borderRadius='20px'
              customCloseIcon={customCloseIcon}
              Content={
                <div className={classes.modalContainer}>
                  <Grid container spacing={2}>
                    <Grid item sm={6} className={classes.modalItem}>
                      <Typography variant='body1' gutterBottom>
                        {t('general.date')}
                      </Typography>
                      <Grid item xs={12} className={classes.datePicker}>
                        <DateRangeIcon />
                        <Typography variant='body1'>
                          {date.format('DD.MM.YYYY')}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid item sm={6} className={classes.modalItem}>
                      <Typography variant='body1' gutterBottom>
                        {t('general.time')}
                      </Typography>
                      <Grid item xs={12} className={classes.datePicker}>
                        <TimeRangeIcon />
                        <Typography variant='body1'>
                          {date.format('HH:mm')}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid item xs={12}>
                      <Button
                        onClick={() => {
                          reserveShowing(showing.showingId)
                          setIsLoaing(true)
                        }}
                        className={classes.primaryBtn}
                      >
                        {isLoading ? (
                          <CircularProgress
                            size={25}
                            style={{ color: '#fff' }}
                          />
                        ) : (
                          t('showings.createShowings.form.confirmShowing')
                        )}
                      </Button>
                    </Grid>
                    <Grid item xs={12}>
                      <Suggest
                        isModal
                        content={t('showings.reserve.hints.noTimes')}
                        containerMaxWidth='900px'
                        contentMaxWidth='900px'
                      />
                    </Grid>
                  </Grid>
                </div>
              }
            />
          </Fragment>
        )
      })}
    </Grid>
  )
}

export default SuggestReservableCard
